import { useLocation, useNavigate } from "react-router-dom";
import { SuperAdminRoutes } from "../../utils/SuperAdminRoutes";
import { AdminRoutes } from "../../utils/AdminRoutes";
import { StoreRoutes } from "../../utils/StoreRoutes";
import { sidebarItems } from "./sidebarItems";

export function useSidebar() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const superAdminRoutes = SuperAdminRoutes();
  const adminRoutes = AdminRoutes();
  const storeRoutes = StoreRoutes();

  const isSuperAdminRoute = superAdminRoutes.includes(pathname);
  const isAdminRoute = adminRoutes.includes(pathname);
  const isStoreRoute = storeRoutes.includes(pathname);

  const handleNavigation = (route) => {
    navigate(route);
  };

  const getRoute = (item) => {

    if (!item.route) {
      return null;
    }

    if (isSuperAdminRoute) {
      return item.route.superadmin;
    }

    if (isAdminRoute) {
      return item.route.admin;
    }

    if (isStoreRoute) {
      return item.route.store;
    }

    return null;
  };

  const getLabel = (item) => {

    if (typeof item.label === "object" && !Array.isArray(item.label)) {

      if (isSuperAdminRoute) {
        return item.label.superadmin;
      }

      if (isAdminRoute) {
        return item.label.admin;
      }

      if (isStoreRoute) {
        return item.label.store;
      }

    }

    return item.label;
  };

  const menuItems = sidebarItems.filter(item => {

    if (isSuperAdminRoute && item.hideForSuperAdmin) {
      return false;
    }

    if (item.superAdminOnly && !isSuperAdminRoute) {
      return false;
    }

    if (item.adminOnly && !isAdminRoute) {
      return false;
    }

    return true;

  });

  const topItems = menuItems.filter(item => !item.bottom);
  const bottomItems = menuItems.filter(item => item.bottom);

  return {
    topItems,
    bottomItems,
    getRoute,
    getLabel,
    handleNavigation
  };
}